import { faCircleCheck, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import 'react-toastify/dist/ReactToastify.css';
import { Icon } from '@iconify/react';

function Part2CertIn(props) {

    const {
        certInVulCount, setCertInVulCount, handleCertInDownload, certInCurrentPage,
        handlePrevPage, handleNextPage, handleCancel,
        certInCritical, setCertInCritical, inchargeName, setInchargeName, inchargeEmail, setInchargeEmail, inchargeDesignation, setInchargeDesignation,
        certInHigh, setCertInHigh,
        certInMedium, setCertInMedium,
        certInLow, setCertInLow,
        certInInfo, setCertInInfo, handleCertInCancel,
        certInA1, setCertInA1, certInA2, setCertInA2, certInA3, setCertInA3, certInA4, setCertInA4, certInA5, setCertInA5,
        certInA6, setCertInA6, certInA7, setCertInA7, certInA8, setCertInA8, certInA9, setCertInA9, certInA10, setCertInA10
    } = props
    return (
        <div className='report_part2'>
            <div className='report_part2_content'>
                <div className='report_part2_heading'>
                    <h1>Part 2 Web Cert-In Format</h1>
                </div>
                <div className='report_part2_input'>
                    <div className='report_part2_leftside'>

                        <div className='report_input'>
                            <div style={{ display: "flex" }}>
                                <label>Organization Incharge Name</label>
                            </div>
                            <input type='text' placeholder='Organization Incharge Name' value={inchargeName} onChange={(e) => setInchargeName(e.target.value)} />
                        </div>

                        <div className='report_input'>
                            <div style={{ display: "flex" }}>
                                <label>Organization Incharge Email</label>
                            </div>
                            <input type='email' placeholder='Organization Incharge Email' value={inchargeEmail} onChange={(e) => setInchargeEmail(e.target.value)} />
                        </div>

                        <div className='report_input'>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <label>Organization Incharge Designation</label>
                                <p style={{ fontSize: "11px", textAlign: "left", marginBottom: "3px", color: "#2E89E4" }}>If not applicable enter N/A</p>

                            </div>
                            <input type='text' placeholder='Organization Incharge Designation' value={inchargeDesignation} onChange={(e) => setInchargeDesignation(e.target.value)} />
                        </div>

                        <div className='report_input'>
                            <div style={{ display: "flex" }}>
                                <label>No. of vulnerabilities </label>
                            </div>

                            <input type='text' placeholder='Count Of Vulnerabilities' value={certInVulCount} onChange={(e) => setCertInVulCount(e.target.value)} />
                            <p style={{ fontSize: "11px", textAlign: "left", color: "#2E89E4",marginTop:"5px",marginBottom:"5px" }}>Example: Twenty(20)</p>

                        </div>

                        <div className='report_input'>
                            <h3 style={{ marginTop: "4px" }}>
                                Severity risk rating </h3>
                            <table style={{ width: "250px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: "70px" }}>Severity level</th>
                                        <th style={{ width: "70px" }}>Frequency</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "70px" }}>Critical</td>
                                        {/*<td style={{ width: "70px" }}><input type='number' style={{ width: "70px", height: "10px", marginBottom: "2px" }} value={certInCritical} onChange={(e) => setCertInCritical(e.target.value)} /></td>*/}
                                        <td style={{ width: "70px", backgroundColor: "#f0f0f0" }}>
                                            <div className="content-box">
                                                <button
                                                    type="button"
                                                    className='decrease_button'
                                                    onClick={() => setCertInCritical(prev => Math.max(0, Number(prev) - 1))}
                                                >−</button>
                                                <input
                                                    type="number"
                                                    className="input"
                                                    style={{ width: "55px", height: "10px", margin: "0 2px", backgroundColor: "transparent", textAlign: "center" }}
                                                    value={certInCritical}
                                                    onChange={(e) => setCertInCritical(e.target.value)}
                                                />
                                                <button
                                                    type="button"
                                                    className='increase_button'
                                                    onClick={() => setCertInCritical(prev => Number(prev) + 1)}
                                                >+</button>
                                            </div>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}>High</td>
                                        {/*<td style={{ width: "70px" }}><input type='number' style={{ width: "70px", height: "10px", marginBottom: "2px" }} value={certInHigh} onChange={(e) => setCertInHigh(e.target.value)} /></td>*/}
                                        <td style={{ width: "70px", backgroundColor: "#f0f0f0" }}>
                                            <div className="content-box">
                                                <button
                                                    type="button"
                                                    className='decrease_button'
                                                    onClick={() => setCertInHigh(prev => Math.max(0, Number(prev) - 1))}
                                                >−</button>
                                                <input
                                                    type="number"
                                                    className="input"
                                                    style={{ width: "55px", height: "10px", margin: "0 2px", backgroundColor: "transparent", textAlign: "center" }}
                                                    value={certInHigh}
                                                    onChange={(e) => setCertInHigh(e.target.value)}
                                                />
                                                <button
                                                    type="button"
                                                    className='increase_button'
                                                    onClick={() => setCertInHigh(prev => Number(prev) + 1)}
                                                >+</button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}>Medium</td>
                                        {/*<td style={{ width: "70px" }}><input type='number' style={{ width: "70px", height: "10px", marginBottom: "2px" }} value={certInMedium} onChange={(e) => setCertInMedium(e.target.value)} /></td>*/}
                                        <td style={{ width: "70px", backgroundColor: "#f0f0f0" }}>
                                            <div className="content-box">
                                                <button
                                                    type="button"
                                                    className='decrease_button'
                                                    onClick={() => setCertInMedium(prev => Math.max(0, Number(prev) - 1))}
                                                >−</button>
                                                <input
                                                    type="number"
                                                    className="input"
                                                    style={{ width: "55px", height: "10px", margin: "0 2px", backgroundColor: "transparent", textAlign: "center" }}
                                                    value={certInMedium}
                                                    onChange={(e) => setCertInMedium(e.target.value)}
                                                />
                                                <button
                                                    type="button"
                                                    className='increase_button'
                                                    onClick={() => setCertInMedium(prev => Number(prev) + 1)}
                                                >+</button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}>Low</td>
                                        {/*<td style={{ width: "70px" }}><input type='number' style={{ width: "70px", height: "10px", marginBottom: "2px" }} value={certInLow} onChange={(e) => setCertInLow(e.target.value)} /></td>*/}
                                        <td style={{ width: "70px", backgroundColor: "#f0f0f0" }}>
                                            <div className="content-box">
                                                <button
                                                    type="button"
                                                    className='decrease_button'
                                                    onClick={() => setCertInLow(prev => Math.max(0, Number(prev) - 1))}
                                                >−</button>
                                                <input
                                                    type="number"
                                                    className="input"
                                                    style={{ width: "55px", height: "10px", margin: "0 2px", backgroundColor: "transparent", textAlign: "center" }}
                                                    value={certInLow}
                                                    onChange={(e) => setCertInLow(e.target.value)}
                                                />
                                                <button
                                                    type="button"
                                                    className='increase_button'
                                                    onClick={() => setCertInLow(prev => Number(prev) + 1)}
                                                >+</button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}>Information</td>
                                        {/*<td style={{ width: "70px" }}><input type='number' style={{ width: "70px", height: "10px", marginBottom: "2px" }} value={certInInfo} onChange={(e) => setCertInInfo(e.target.value)} /></td>*/}
                                        <td style={{ width: "70px", backgroundColor: "#f0f0f0" }}>
                                            <div className="content-box">
                                                <button
                                                    type="button"
                                                    className='decrease_button'
                                                    onClick={() => setCertInInfo(prev => Math.max(0, Number(prev) - 1))}
                                                >−</button>
                                                <input
                                                    type="number"
                                                    className="input"
                                                    style={{ width: "55px", height: "10px", margin: "0 2px", backgroundColor: "transparent", textAlign: "center" }}
                                                    value={certInInfo}
                                                    onChange={(e) => setCertInInfo(e.target.value)}
                                                />
                                                <button
                                                    type="button"
                                                    className='increase_button'
                                                    onClick={() => setCertInInfo(prev => Number(prev) + 1)}
                                                >+</button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                    <div className='report_part2_rightside'>
                        <div className='report_input'>
                            <h3>OWASP Top 10 list</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Vulnerabilities</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Broken Access Control</td>
                                        <td>
                                            <select style={{ width: "200px", marginTop: "2px", marginBottom: "2px" }} value={certInA1} onChange={(e) => setCertInA1(e.target.value)}>
                                                <option>Select</option>
                                                <option>Protected</option>
                                                <option>UnProtected</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Security Misconfiguration</td>
                                        <td>
                                            <select style={{ width: "200px", marginTop: "2px", marginBottom: "2px" }} value={certInA2} onChange={(e) => setCertInA2(e.target.value)}>
                                                <option>Select</option>
                                                <option>Protected</option>
                                                <option>UnProtected</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Software Supply Chain Failures </td>
                                        <td>
                                            <select style={{ width: "200px", marginTop: "2px", marginBottom: "2px" }} value={certInA3} onChange={(e) => setCertInA3(e.target.value)}>
                                                <option>Select</option>
                                                <option>Protected</option>
                                                <option>UnProtected</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Cryptographic Failures</td>
                                        <td>
                                            <select style={{ width: "200px", marginTop: "2px", marginBottom: "2px" }} value={certInA4} onChange={(e) => setCertInA4(e.target.value)}>
                                                <option>Select</option>
                                                <option>Protected</option>
                                                <option>UnProtected</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Injection</td>
                                        <td>
                                            <select style={{ width: "200px", marginTop: "2px", marginBottom: "2px" }} value={certInA5} onChange={(e) => setCertInA5(e.target.value)}>
                                                <option>Select</option>
                                                <option>Protected</option>
                                                <option>UnProtected</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Insecure Design</td>
                                        <td>
                                            <select style={{ width: "200px", marginTop: "2px", marginBottom: "2px" }} value={certInA6} onChange={(e) => setCertInA6(e.target.value)}>
                                                <option>Select</option>
                                                <option>Protected</option>
                                                <option>UnProtected</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Authentication Failures</td>
                                        <td>
                                            <select style={{ width: "200px", marginTop: "2px", marginBottom: "2px" }} value={certInA7} onChange={(e) => setCertInA7(e.target.value)}>
                                                <option>Select</option>
                                                <option>Protected</option>
                                                <option>UnProtected</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Software and Data Integrity Failures</td>
                                        <td>
                                            <select style={{ width: "200px", marginTop: "2px", marginBottom: "2px" }} value={certInA8} onChange={(e) => setCertInA8(e.target.value)}>
                                                <option>Select</option>
                                                <option>Protected</option>
                                                <option>UnProtected</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Security Logging and Alerting Failures</td>
                                        <td>
                                            <select style={{ width: "200px", marginTop: "2px", marginBottom: "2px" }} value={certInA9} onChange={(e) => setCertInA9(e.target.value)}>
                                                <option>Select</option>
                                                <option>Protected</option>
                                                <option>UnProtected</option>
                                            </select>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Mishandling of Exceptional Conditions</td>
                                        <td>
                                            <select style={{ width: "200px", marginTop: "2px", marginBottom: "2px" }} value={certInA10} onChange={(e) => setCertInA10(e.target.value)}>
                                                <option>Select</option>
                                                <option>Protected</option>
                                                <option>UnProtected</option>
                                            </select>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                    </div>


                </div>

                <div className='report_part1_button'>
                    <Icon icon="stash:arrow-left-light" onClick={handlePrevPage} className="prev_icon" />
                    {/*<button style={{ fontSize: "13px", marginRight: "20px" }} onClick={handlePrevPage}>Prev</button>*/}
                    <button className='part1_cancel_button' onClick={handleCertInCancel}>Cancel</button>
                    {/* <button className='part2_draft_button' onClick={handleDraftClick} disabled={disableDraft}>Draft</button> */}
                    <button className='part1_upload_button' onClick={handleCertInDownload}>Download</button>
                    {/*<button style={{ fontSize: "13px", marginLeft: "20px" }} onClick={handleNextPage} >Next</button>*/}
                    <Icon icon="stash:arrow-right-light" onClick={handleNextPage} className="next_icon" />

                </div>

            </div>

        </div>
    )
}

export default Part2CertIn
